import {
  File,
  FileBraces,
  FileCode,
  FileImage,
  FilePlay,
  FileSpreadsheet,
  FileText,
  Presentation,
  type LucideIcon,
} from 'lucide-react'
import { classifyFile } from '../../lib/file-classification'
import { cn } from '../../lib/utils'

function getExtension(filePath: string): string {
  const withoutQuery = filePath.split(/[?#]/, 1)[0] ?? filePath
  const basename = withoutQuery.split(/[\\/]/).pop() ?? withoutQuery
  const dotIndex = basename.lastIndexOf('.')
  if (dotIndex === -1 || dotIndex === 0) return ''
  return basename.slice(dotIndex + 1).toLowerCase()
}

export function getMarkdownFileLinkIcon(path: string): LucideIcon {
  const type = classifyFile(path).type

  switch (type) {
    case 'image':
      return FileImage
    case 'video':
      return FilePlay
    case 'code':
      return FileCode
    case 'json':
      return FileBraces
    case 'pdf':
    case 'markdown':
    case 'text':
      return FileText
    case 'office': {
      const ext = getExtension(path)
      if (ext === 'xls' || ext === 'xlsx') return FileSpreadsheet
      if (ext === 'ppt' || ext === 'pptx') return Presentation
      return FileText
    }
    default:
      return File
  }
}

export function MarkdownFileLinkIcon({
  path,
  className,
}: {
  path: string
  className?: string
}) {
  const Icon = getMarkdownFileLinkIcon(path)

  return (
    <Icon
      aria-hidden="true"
      focusable="false"
      className={cn(
        'mr-1 inline-block h-3.5 w-3.5 shrink-0 align-[-0.18em] text-muted-foreground/70 pointer-events-none select-none',
        className,
      )}
    />
  )
}
